<template>
    <v-container>
        <v-layout align-center justify-center fill-height>
            <v-flex xs12 sm7 md6 lg5 xl3>
                <h2 style="text-align: center;">
                    <strong>
                        <span style=" text-align: center;">Código de Acceso para Elevador</span>
                    </strong>
                </h2>
                <p style="text-align: center;">Escanea este código en el lector de QR del Elevador.</p>
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('qr_code')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="mt-4">
                        <v-row>
                            <v-flex xs12>
                                <v-img
                                        class="centrado"
                                        :src="url"
                                        width="200"
                                        height="200"
                                >
                                </v-img>
                                <br>
                            </v-flex>
                        </v-row>
                    </v-card-text>
                    <p style="text-align: center;">Este código caducará en 15 minutos.</p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "qr_code_elevator",
        data(){
            return{
                url: "https://api.qrserver.com/v1/create-qr-code/?data=" + this.$route.params['qrcode'] + "&ecc=M&margin=20&size=400x400"
            }
        }
    }
</script>

<style scoped>
    .centrado{
        display:block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
